const value = {
    login: 'Sign In',
    learning: 'Learning',
    notifications: 'Notifications',
    analytics: 'Analytics',
    settings: 'Settings',
    projects: 'Projects',
    project: 'Project',
    systemPage: 'System page',
    editProject: 'Edit project',
    addProject: 'Add project',
    passing: 'Unit passing',
    editUnit: 'Edit unit',
    createUnit: 'Create unit',
    unitPreview: 'Unit preview',
    userRating: 'User rating',
  };

export default value;
